export const AIRBRIDGE = {
  APP_NAME: 'heydusd',
  WEB_TOKEN: 'edb44954f082418c97d116327a34a620',

  EVENT: {
    SIGN_UP: 'airbridge.user.signup',
    SIGN_IN: 'airbridge.user.signin',
    HOME_VIEW: 'airbridge.ecommerce.home.viewed',
    SIGN_OUT: 'airbridge.user.signout',
    SEND_MESSAGE: 'send_message',
    INITIATE_CHECKOUT: 'airbridge.initiateCheckout', // v1.1 added
    ORDER_COMPLETED: 'airbridge.ecommerce.order.completed', // v1.1 added
    CLICK_BUY_DART: 'click_buy_dart',
  },
} as const;
